import React, { Component } from "react";
import { Link } from "react-router-dom";
import { loading } from "../components/CustomComponent.js";
import { Btn } from "../components/ui.js";
import { MascotBot } from "../components/illustrations.js";

/* LEVELUP ONE — เข้าสู่ระบบ (Login) */
export default class Login extends Component {
  state = { email: "", password: "", error: "", done: false };
  componentDidMount() { loading(false); window.scrollTo(0, 0); }

  submit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return this.setState({ error: "กรุณากรอกอีเมลให้ถูกต้อง" });
    if (password.length < 6) return this.setState({ error: "รหัสผ่านอย่างน้อย 6 ตัวอักษร" });
    this.setState({ error: "", done: true });
  };

  render() {
    const { email, password, error, done } = this.state;
    return (
      <div className="nx">
        <div className="nx-auth">
          <aside className="nx-auth__aside">
            <Link to="/" className="nx-brand" style={{ color: "#fff" }}>
              <span className="nx-brand__mark" style={{ background: "rgba(255,255,255,0.2)" }}>L</span>
              <span className="nx-brand__name" style={{ color: "#fff" }}>LevelUp One</span>
            </Link>
            <div className="mt-auto" style={{ marginTop: 40 }}>
              <MascotBot style={{ width: 130, height: "auto" }} />
              <h2 className="mt-3">ยินดีต้อนรับกลับ</h2>
              <p>เข้าสู่ระบบเพื่อจัดการพนักงาน AI และดูแดชบอร์ดธุรกิจของคุณ</p>
              <ul className="nx-auth__points">
                <li>ดูยอดขายและรายงานแบบเรียลไทม์</li>
                <li>สั่งงานทีม AI ได้ทุกที่</li>
                <li>ปลอดภัยด้วยการยืนยันตัวตน</li>
              </ul>
            </div>
            <div></div>
          </aside>

          <main className="nx-auth__main">
            <div className="nx-auth__card">
              {done ? (
                <div className="text-center">
                  <div style={{ fontSize: "3rem" }}>✅</div>
                  <h1 className="nx-ink mt-2">เข้าสู่ระบบสำเร็จ</h1>
                  <p className="nx-muted mb-4">นี่เป็นเดโม UI — ระบบหลังบ้านยังไม่เชื่อมต่อ</p>
                  <Btn to="/">ไปหน้าแรก</Btn>
                </div>
              ) : (
                <>
                  <h1 className="nx-ink">เข้าสู่ระบบ</h1>
                  <p className="nx-muted mb-4">ยังไม่มีบัญชี? <Link to="/register" className="nx-primary">สมัครสมาชิก</Link></p>
                  <form onSubmit={this.submit} noValidate>
                    <div className="nx-field">
                      <label className="nx-label">อีเมล</label>
                      <input className="nx-input" type="email" value={email} placeholder="you@email.com"
                        onChange={(e) => this.setState({ email: e.target.value, error: "" })} />
                    </div>
                    <div className="nx-field">
                      <label className="nx-label">รหัสผ่าน</label>
                      <input className="nx-input" type="password" value={password} placeholder="••••••••"
                        onChange={(e) => this.setState({ password: e.target.value, error: "" })} />
                    </div>
                    {error && <p className="text-danger" style={{ fontSize: "0.88rem" }}>{error}</p>}
                    <button type="submit" className="nx-btn nx-btn--primary nx-btn--block mt-2">เข้าสู่ระบบ</button>
                  </form>
                  <p className="text-center mt-4"><Link to="/" className="nx-muted" style={{ fontSize: "0.9rem" }}>← กลับหน้าแรก</Link></p>
                </>
              )}
            </div>
          </main>
        </div>
      </div>
    );
  }
}
